export const AGT_PASSWORD = 'password';
export const AGT_CAREER_PASSWORD = 'career_password';
export const AGT_ANONYMOUS = 'anonymous';
export const AGT_ONE_TIME_TOKEN = 'one_time_token';
export const AGT_THIRD_PARTY_ACCESS_TOKEN = '3rd_party_access_token';
export const AGT_REFRESH_TOKEN = 'refresh_token';

export type AuthGrantType = (
  | typeof AGT_PASSWORD
  | typeof AGT_CAREER_PASSWORD
  | typeof AGT_ANONYMOUS
  | typeof AGT_ONE_TIME_TOKEN
  | typeof AGT_THIRD_PARTY_ACCESS_TOKEN
  | typeof AGT_REFRESH_TOKEN
);
